import { i18n } from '@js/i18n'
import { documentTypes } from '@const'

export default {
  form: {
    docs: {
      [documentTypes.kycProofOfAddress]: null
    }
  },
  requiredDocs: [documentTypes.kycProofOfAddress],
  rows: [
    [
      {
        "heading": i18n.kyc_upload_address_proof()
      }
    ],
    [
      {
        "list": [i18n.kyc_driver_license(),
                i18n.kyc_corporate_copy_current_tax(),
                i18n.kyc_corporate_copy_bank_statement(),
                i18n.kyc_corporate_copy_utility_bill()]
      }
    ],
    [
      {
        "name": "kyc-address-proof",
        "id":  "kyc-address-proof",
        "label": i18n.kyc_upload_address(),
        "field": "file",
        "side": "front",
        "fileType": "image",
        "required": true,
        "type": documentTypes.kycProofOfAddress,
        "validate": "required"
      }
    ]
  ]
}



// WEBPACK FOOTER //
// ./src/vue/app/verification/spec/syndicate/step-6.address-proof.schema.js